module.exports = __webpack_public_path__ + "static/pistola_final_3-94ab6366a40f27e69589bf297ac54ef4.png";